/**
 * Pending-invite handoff (#495): when a logged-out user opens
 * /join?token=..., the invite is parked in localStorage so it survives
 * the signup/login round-trip, then auto-accepted on the next
 * authenticated visit. Storage is per-origin, so App.tsx must keep the
 * user on the current host (no tenant-subdomain redirect) while an
 * invite is pending.
 */

export interface PendingInvite {
  token: string;
  /** Display hints from the invite email CTA — never authoritative. */
  email?: string;
  workspace?: string;
  role?: string;
  inviter?: string;
}

const KEY = 'systemdox.pendingInvite';

export function savePendingInvite(invite: PendingInvite): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(invite));
  } catch {
    // Storage full/blocked — the /join URL itself still carries the token.
  }
}

export function loadPendingInvite(): PendingInvite | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed.token === 'string' && parsed.token ? parsed : null;
  } catch {
    return null;
  }
}

export function clearPendingInvite(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
